import Model from './model.js'

export default {
  ReadAsMaster: function(params) {
    if(params.action === 'ASSET'){
      params.data.query = 'Asset/Master/';
    }else if(params.action === 'CONTRACTOR'){
      params.data.query = 'Master/Contractor/';
    }else if(params.action === 'CITY'){
      params.data.query = 'Master/City-In-CoverageMaster/';
    }else if(params.action === 'CURRENCY'){
      params.data.query = 'Master/Currencies/';
    }else {
      params.data.query = 'Maintenance/Service/Master/';
    }
    Model.ReadAsMaster(params);
  },
  Read: function(params) {
    let cluster = params.self.props.Cluster;
    if(params.action === 'Next') {
      params.data.url = params.self.state.nextPage;
    }

    if(cluster === 'all') {
      params.data.status = 'all';

    } else if(cluster === 'upcoming') {
      params.data.status = 'upcoming';

    } else if(cluster === 'ongoing') {
      params.data.status = 'ongoing';
      
    } else if(cluster === 'past') {
      params.data.status = 'past';
    }

    Model.Read(params);
  },
  ReadByAsset: function(params) {
    if(params.action === 'Work') {
      params.data.api = 'Maintenance/Work/Asset/'

    } else if(params.action === "Request"){
      params.data.api = 'Maintenance/Request/'

    } else if(params.action === "Next") {
      params.data.url = params.self.state.NextPage;
    }

    Model.ReadByAsset(params);
  },
  Register: function(params) {
    Model.Register(params);
  },
  RegisterRequestMaintenance: function(params) {
    Model.RequestMaintenance(params);
  },
  RegisterReport: function(params) {
    Model.RegisterReport(params);
  },
  Update: function(params) {
    Model.Update(params);
  },
  StartWork: function(params) {
    Model.StartWork(params);
  },
  QuickTest: function(params) {
    Model.QuickTest(params);
  },
  FinishWork: function(params) {
    Model.FinishWork(params);
  },
  RegisterReminder: function(params) {
    Model.RegisterReminder(params);
  },
  UpdateReminder: function(params) {
    Model.UpdateReminder(params);
  },
  ReadReminderByWork: function(params) {
    Model.ReadReminderByWork(params);
  },
}


// WEBPACK FOOTER //
// ./src/App/maintenance/presenter.js